export default __webpack_public_path__ + "assets/front/scss/affichage-table.5f6da927d84f49e0eb57e8d7a10b243f.css";